import { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

const isObject = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

const hasDataResponseErrorShape = (
    value: unknown
): value is Pick<IDataResponseError, 'message' | 'errors'> =>
    isObject(value) && ('message' in value || 'errors' in value);

const getErrorTitles = (errors: IDataResponseError['errors']) =>
    errors
        ?.map((error) => error.title?.trim())
        .filter(Boolean)
        .join('; ');

const getErrorTextFromPayload = (payload: unknown): string => {
    if (!hasDataResponseErrorShape(payload)) {
        return '';
    }

    const message = typeof payload.message === 'string' ? payload.message.trim() : '';

    if (message) {
        return message;
    }

    return getErrorTitles(payload.errors) || '';
};

export const getCommentsRequestErrorText = (
    error: unknown,
    fallbackText: string = ''
): string => {
    if (isObject(error) && 'response' in error && isObject(error.response) && 'data' in error.response) {
        const responseErrorText = getErrorTextFromPayload(error.response.data);

        if (responseErrorText) {
            return responseErrorText;
        }
    }

    if (error instanceof Error) {
        const message = error.message?.trim();

        if (message) {
            return message;
        }
    }

    return fallbackText;
};
